import {useState} from 'react';
import {NavLink, useLocation} from 'react-router-dom';

import {
  Nav,
  NavItem,
  NavLink as NavItemLink,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
} from 'reactstrap';
import PublicNavActions from './PublicNavActions';

import cx from 'classnames';
import styles from './styles.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';

function PublicNavDesktop(props) {
  const {navItems, hideMenu, utmProps} = props;
  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;

  if (!navItems) return null;

  return (
    <>
      {!hideMenu && (
        <Nav className="mx-auto">
          {navItems.map((item, key) => {
            const {to, text} = item;
            const isActive =
              currentPath === to || location.pathname.startsWith(item.parent);

            if (!item.headers) {
              return (
                <NavItem key={key}>
                  <NavItemLink
                    tag={NavLink}
                    exact
                    to={to}
                    color="link"
                    className={cx(
                      'font-weight-bold',
                      styles['dropdown__link'],
                      {
                        [styles['dropdown__link--active']]: currentPath === to,
                      }
                    )}
                  >
                    {text}
                  </NavItemLink>
                </NavItem>
              );
            }
            return (
              <UncontrolledDropdown key={key}>
                <DropdownToggle
                  color="link"
                  className={cx(
                    styles['dropdown__link'],
                    styles['dropdown__menu--parent'],
                    'text-decoration-none',
                    {
                      [styles['dropdown__link--active']]: isActive,
                    }
                  )}
                  onClick={() => {
                    setIsOpen(!isOpen);
                  }}
                >
                  {item.text} <MuiIcon name="expand_more" />
                </DropdownToggle>

                <DropdownMenu key={key}>
                  {item.headers.map((header, headerIndex) => (
                    <ul
                      key={headerIndex}
                      className={styles['dropdown--header']}
                    >
                      {header.header && (
                        <DropdownItem header className="font-weight-bold mt-2">
                          {header.header}
                        </DropdownItem>
                      )}
                      {header.children.map((child, childIndex) => (
                        <NavItem key={childIndex}>
                          <NavItemLink
                            tag={NavLink}
                            to={child.to}
                            exact
                            color="link"
                            className={cx(
                              styles['dropdown__link--mobile'],
                              'py-1 px-0'
                            )}
                          >
                            <DropdownItem
                              className={cx(
                                styles['dropdown__link'],
                                styles['dropdown__link--mobile'],
                                {
                                  [styles['dropdown__link--active']]:
                                    currentPath === child.to,
                                }
                              )}
                            >
                              {child.text}
                            </DropdownItem>
                          </NavItemLink>
                        </NavItem>
                      ))}
                    </ul>
                  ))}
                </DropdownMenu>
              </UncontrolledDropdown>
            );
          })}
        </Nav>
      )}

      <PublicNavActions utmProps={utmProps} />
    </>
  );
}

export default PublicNavDesktop;
